import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import Swal from "sweetalert2";
import { createMonthlyReportService } from "../sevices/createMonthlyReport.service.js";

const initialState = {
  file: null,
  observations: null,
  date: "",
};

export const useMonthlyReportCommand = (refresh) => {
  const fetchData = useFetch();
  const [monthlyReport, setMonthlyReport] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });

  const handleChange = ({ name, value }) => {
    setMonthlyReport((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const setDefaultValues = (defaultValues) => {
    setMonthlyReport(defaultValues || initialState);
  };

  const create = async () => {
    try {
      setLoading(true);
      const isValid = validations(monthlyReport);
      if (!isValid) return;

      const formData = new FormData();
      formData.append("file", monthlyReport.file);
      formData.append("observations", monthlyReport.observations);
      formData.append("date", monthlyReport.date);

      const response = await createMonthlyReportService(fetchData)(formData);
      refresh?.();
      Swal.fire({
        title: "Exito",
        text: response.message,
        icon: "success",
      });
      setMonthlyReport(initialState);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const validations = (monthlyReport) => {
    const newErrors = {};

    if (!monthlyReport.file) {
      newErrors.file = "Debes elegir un archivo";
    }

    if (!monthlyReport.date) {
      newErrors.date = "La fecha es obligatorio";
    }

    const hasErros = Object.keys(newErrors).length > 0;
    setErrors({ hasErros, errors: newErrors });
    return !hasErros;
  };

  return {
    monthlyReport,
    handleChange,
    errors,
    createMonthlyReport: create,
    setDefaultValues,
    loading,
  };
};
